// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import MailIcons from './MailIcons';

export type MailIconsSubset = { [icon in MailIcons]: string };

export let MailIconsDefinitions: MailIconsSubset = {
    AlertSettings: '\uf8b6',
    AssignPolicy: '\ue461',
    Broom: '\uea99',
    ChevronDownSmall: '\ue96e',
    ChevronRightSmall: '\ue970',
    ChevronUpSmall: '\ue96d',
    Comment: '\ue90a',
    ContactInfo: '\ue779',
    CreateMailRule: '\uf67a',
    DateTime2: '\uea17',
    DietPlanNotebook: '\ueac8',
    DislikeSolid: '\uf3c0',
    DownloadDocument: '\uf549',
    DRM: '\ueca8',
    EditNote: '\ued9d',
    FabricSyncFolder: '\uf0a7',
    Fax: '\uef5c',
    FileBug: '\uf30d',
    Giftbox: '\uec1f',
    Highlight: '\ue7e6',
    IgnoreConversation: '\ue372',
    InboxCheck: '\uef64',
    IRMForward: '\uf41f',
    IRMReply: '\uf41d',
    LightningBoltSolid: '\ue45f',
    LikeSolid: '\uf3bf',
    MailLowImportance: '\ued82',
    MailReplyAll: '\ue8c2',
    Memo: '\ue77c',
    MultiSelectMirrored: '\uea98',
    News: '\ue900',
    OutOfOffice: '\ued34',
    Pin: '\ue718',
    ProgressRingDots: '\uf16a',
    ReadingMode: '\ue736',
    ReadOutLoud: '\uf112',
    ReceiptCheck: '\uef5b',
    ReceiptForward: '\uef59',
    ReceiptReply: '\uef5a',
    RecurringTask: '\uedb2',
    RevToggleKey: '\ue845',
    ShoppingCart: '\ue7bf',
    SyncOccurenceCancel: '\uf7e7',
    TagGroup: '\ue3f6',
    TaskLogo: '\uf493',
    UnavailableOffline: '\ue545',
    UserOptional: '\uf767',
    VerifiedBrand: '\uf7bd',
    VoicemailForward: '\ued87',
    VoicemailIRM: '\uf421',
    VoicemailReply: '\ued88',
};

export default {
    fontFileName: 'mailIcons',
    icons: MailIconsDefinitions,
};
